import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {rgbaToHexString} from '@Utils/color.util';
import {colorToRgbaArray} from '@Utils/color.util';
import {BaseCustomShadowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-custom-shadow-color-panel';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem';

export function TranscriptShadowPanel(): ReactElement<any> | null {
  const activeItem = useGetSelectedTranscriptItem();
  const activeTranscriptItemDropShadowColor = useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem('color');
  if (activeTranscriptItemDropShadowColor === null) {
    return null;
  }

  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptShadowPanel');
  }
  if (activeTranscriptItemDropShadowColor === undefined) {
    throw new Error('Transcript item subtitles do not have a shadow property');
  }

  const updateCustomShadow = (dropShadowColor: RGBA, undoable = true): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        shadow: {
          ...activeItem.toObject().shadow,
          color: rgbaToHexString(dropShadowColor),
        },
      },
      {undoable}
    );
  };

  return <BaseCustomShadowColorPanel dropShadowColor={colorToRgbaArray(activeTranscriptItemDropShadowColor)} onUpdateColor={updateCustomShadow} />;
}
